import { Typography } from "@circle-react-uikit/Typography";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { useBlocksContext } from "../../contexts/BlocksContext";

interface ThankYouPageProps {
  isModal?: boolean;
  usage?: "newsletter" | "page";
}
export const EndingPage = ({ usage, isModal = false }: ThankYouPageProps) => {
  const { useFormRenderingContext } = useBlocksContext();
  const { form, formBackgroundColor, formTextColor, formHeight, isPreview } =
    useFormRenderingContext();
  const uid = form.uid;
  return (
    <div
      id={`thank-you-${uid}`}
      style={{
        height: formHeight,
        backgroundColor: formBackgroundColor,
      }}
      className={classNames(
        "flex size-full max-h-[600px] flex-col items-center justify-center gap-2 px-8 py-12 text-center",
        {
          "rounded-md": isPreview,
          "!pt-0": isModal,
          "max-w-[600px]": !usage,
        },
      )}
    >
      <style>{`#thank-you-${uid} h4, #thank-you-${uid} p { color: ${formTextColor}; }`}</style>
      <Typography.TitleMd>{form.thank_you_page_title}</Typography.TitleMd>
      <Typography.BodyMd>{form.thank_you_page_body}</Typography.BodyMd>
    </div>
  );
};
